import { transformBrandToLeanBrand } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/adapters";
import { ILeanProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { ILayoutElementData } from "@faire/web-api--source/indigofair/data/ILayoutElementData";
import { ILeanProductWithBrandTile as ImportLeanProductWithBrandTile } from "@faire/web-api--source/indigofair/data/ILeanProductWithBrandTile";
import { IProductWithBrandTile } from "@faire/web-api--source/indigofair/data/IProductWithBrandTile";

export type ILeanProductWithBrandTile = ImportLeanProductWithBrandTile;

export namespace ILeanProductWithBrandTile {
  export const fromProductWithBrandTile = (
    productWithBrandTile: IProductWithBrandTile,
    strictLocalize: StrictLocalizeFunction
  ): ImportLeanProductWithBrandTile => ({
    product: ILeanProductTile.from(
      productWithBrandTile.product,
      strictLocalize,
      productWithBrandTile.brand,
      undefined,
      productWithBrandTile.promo_string
    ),
    brand: transformBrandToLeanBrand(
      productWithBrandTile.brand ?? IBrand.build()
    ),
  });

  export const fromLayoutElementData = (
    layoutElementData: ILayoutElementData,
    strictLocalize: StrictLocalizeFunction
  ): ImportLeanProductWithBrandTile | undefined => {
    const {
      lean_product_with_brand_tile: leanTile,
      product_with_brand_tile: nonLeanTile,
      lean_product_tile: leanProductTile,
    } = layoutElementData;
    if (leanProductTile) {
      return {
        product: leanProductTile,
        brand: undefined,
      };
    }
    if (leanTile) {
      return leanTile;
    }
    if (nonLeanTile) {
      return fromProductWithBrandTile(nonLeanTile, strictLocalize);
    }
    return undefined;
  };
}
